import { AuthMockApi } from 'app/mock-api/common/auth/api';
import { NavigationMockApi } from 'app/mock-api/common/navigation/api';

export const mockApiServices = [
  AuthMockApi,
  NavigationMockApi,
];
